import React from "react";
import lottieAnimation from "../../../assets/svg/lottie_Animation.json";
import {
  StyledLottie,
  ConfettiHeader,
  AccountInfo,
} from "../../../components/ConfettiPage/ConfettiPage.styles";
import { styled } from "styled-components";
import Buttons from "../../../components/Button/button.component";
import { colors } from "../../../theme/color";

const SuccessfulModal = () => {
  return (
    <Container>
      <InnerDiv>
        <StyledLottie animationData={lottieAnimation} />
        <ConfettiHeader>Payment Successful</ConfettiHeader>
        <AccountInfo>
          You’ve successfully paid <strong>$250.00</strong> for Sanchez bag
        </AccountInfo>
        <Buttons
          disabled
          label="Close"
          width="98%"
          color={colors.ButtonBackgroundColors.primaryMediumHoverButton}
          cursor="pointer"
          border="30px"
          height="48px"
        />
      </InnerDiv>
    </Container>
  );
};

export default SuccessfulModal;

const Container = styled.div`
  width: 535px;
  height: 590px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1.25rem;
  backdrop-filter: blur(1px);
  border-radius: 1.25rem;
  @media screen and (max-width: 320px) {
    display: flex;
    width: 285px;
    height: 728px;
    position: absolute;
    right: -1%;
    top: -1.5%;
  }
  @media only screen and (min-width: 321px) and (max-width: 767px) {
    display: flex;
    width: 309px;
    height: 728px;
    position: absolute;
    right: -1%;
    top: -1.5%;
  }
`;

const InnerDiv = styled.div`
  background-color: white;
  width: 29.5rem;
  height: 21.4375rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 0 2.5rem;
  border-radius: 1.25rem;
`;
